import { useState, useEffect } from "react";
import apis from '../api';

const useParamsAccounting = () => {
    const [params, setParams] = useState([]);
    const headers = {
        authorization: localStorage.getItem('token')
    }
    let payload = {
        CLIENT: localStorage.getItem('client'),
        ENTITY: localStorage.getItem('entity'),
        OPTION: "2"
    }
    useEffect(() => {
        const getParams = async () => {
            let parametros = [];
            let lista = [];
            await apis.postReportAccounting(payload, headers).then(res => {
                parametros = res.data["SHEETS"]
                console.log(res)
            })
            parametros.forEach((element, index) => {
                element["DETAIL"].forEach((row, i) => {
                    if (!(lista.some(l => l.TAG === row.LABEL))) {
                        lista.push({
                            VALUE: "", LABEL: row.NAME, OPTIONS: row.DETAIL, TAG: row.LABEL,
                            SHEET: element.NAME, SHEET_POSITION: [index], POSITION: i, TYPE: row.TYPE_NATIVE, REQUIRED: row.REQUIRED
                        })
                    }
                    else {
                        let pos = lista.findIndex(l => l.TAG === row.LABEL)
                        lista[pos].SHEET_POSITION.push(index);
                        lista[pos].LABEL = row.NAME;
                    }
                })
            })
            setParams(lista)
        }
        getParams()
    }, []);

    return [params];
};

export default useParamsAccounting;